import { render, staticRenderFns } from "./SettingsTableWidget.vue?vue&type=template&id=20f96905"
import script from "./SettingsTableWidget.vue?vue&type=script&lang=js"
export * from "./SettingsTableWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports